import { FC, ReactElement, useState, useMemo } from "react";
import { Box, Divider, Typography } from "@mui/material";

import { ChangePasswordModal } from "@/components";
import { useAppSelector } from "@/store";
import { AccountForm, CompanyForm, StyledButton } from "./components";
import { roles } from "@/roles";

const AccountSettings: FC = (): ReactElement => {
  const { user } = useAppSelector((state) => state.auth);
  const [changePassModalState, setChangePassModalState] = useState(false);
  const handleChangePasswordModalOpen = () => {
    setChangePassModalState(true);
  };

  const isTDAdmin = useMemo(() => {
    return user?.userRole === roles.TDADMIN;
  }, [user]);

  return (
    <>
      <Box px={2.5} py={3.75}>
        <Typography
          variant="h3"
          fontWeight="500"
          color="#030712"
          fontSize="24px"
          lineHeight="30px"
        >
          Account Settings
        </Typography>
        <Typography variant="caption" color="#8D9299" lineHeight="19px">
          There are many variations of passages of Lorem Ipsum available, but
          the majority have suffer
        </Typography>

        <AccountForm user={user} />
      </Box>
      {!isTDAdmin && (
        <>
          <Divider />
          <Box px={2.5} py={3.75}>
            <Typography
              variant="h3"
              fontWeight="500"
              color="#030712"
              fontSize="24px"
              lineHeight="30px"
            >
              Company Information
            </Typography>
            <Typography variant="caption" color="#8D9299" lineHeight="19px">
              There are many variations of passages of Lorem Ipsum available,
              but the majority have suffer
            </Typography>
            {/* <PictureUploader
          title="Company Information"
          description="We recommend an image of at least 400x400."
        /> */}
            <CompanyForm user={user} />
          </Box>
        </>
      )}
      <Divider />
      <Box px={2.5} py={3.75}>
        <Typography
          variant="body1"
          fontWeight="500"
          color="#030712"
          fontSize="18px"
          lineHeight="23px"
        >
          Password
        </Typography>
        <Typography
          variant="body2"
          fontWeight={400}
          color="#8D9299"
          lineHeight="20px"
          sx={{ display: "block", mb: 3 }}
        >
          Change password in every 3 months in order to secure your account
          security
        </Typography>
        <StyledButton
          variant="primary-contained"
          sx={{ minWidth: 208 }}
          onClick={handleChangePasswordModalOpen}
        >
          Change Password
        </StyledButton>
      </Box>
      <Divider />
      {/* <Stack
        direction="row"
        justifyContent="flex-end"
        px={2.5}
        py={3.75}
        spacing={2}
      >
        <StyledButton
          variant="white-outlined"
          sx={{
            color: "#052223",
          }}
        >
          Discard
        </StyledButton>
        <StyledButton variant="primary-contained">Save Changes</StyledButton>
      </Stack> */}
      <ChangePasswordModal
        open={changePassModalState}
        setOpen={setChangePassModalState}
      />
    </>
  );
};

export default AccountSettings;
